import { valibotResolver } from '@hookform/resolvers/valibot';
import { addDays, addMinutes } from 'date-fns';
import { date, nullable, number, object, pipe, toMinValue, union } from 'valibot';

import type { IDeactivateTable } from '@pages/ManageEquipment/model/equipmentsList';

export const EDIT_DEACTIVATION_PERIOD_FIELDS = {
  IS_INDEFINITELY: 'isIndefinitely',
  DEACTIVATE_DATE: 'deactivate_date',
  DEACTIVATE_RANGE_START: 'deactivate_range_start',
  DEACTIVATE_RANGE_END: 'deactivate_range_end',
  REMIND_DATE: 'remind_date',
} as const;

export interface IFormValues {
  [EDIT_DEACTIVATION_PERIOD_FIELDS.IS_INDEFINITELY]: number;
  [EDIT_DEACTIVATION_PERIOD_FIELDS.DEACTIVATE_DATE]: Date;
  [EDIT_DEACTIVATION_PERIOD_FIELDS.DEACTIVATE_RANGE_START]: Date;
  [EDIT_DEACTIVATION_PERIOD_FIELDS.DEACTIVATE_RANGE_END]: Date;
  [EDIT_DEACTIVATION_PERIOD_FIELDS.REMIND_DATE]: Date | null;
}

export const schemaEditEquipmentDeactivationPeriodWithStartDate = valibotResolver(
  object({
    [EDIT_DEACTIVATION_PERIOD_FIELDS.IS_INDEFINITELY]: number(),
    [EDIT_DEACTIVATION_PERIOD_FIELDS.DEACTIVATE_DATE]: date('This field is required.'),
    [EDIT_DEACTIVATION_PERIOD_FIELDS.DEACTIVATE_RANGE_START]: date(),
    [EDIT_DEACTIVATION_PERIOD_FIELDS.DEACTIVATE_RANGE_END]: date(),
    [EDIT_DEACTIVATION_PERIOD_FIELDS.REMIND_DATE]: nullable(date()),
  }),
);

export const schemaEditEquipmentDeactivationPeriod = valibotResolver(
  object({
    [EDIT_DEACTIVATION_PERIOD_FIELDS.IS_INDEFINITELY]: number(),
    [EDIT_DEACTIVATION_PERIOD_FIELDS.DEACTIVATE_RANGE_END]: date(),
    [EDIT_DEACTIVATION_PERIOD_FIELDS.REMIND_DATE]: nullable(date()),
  }),
);

export const editEquipmentDeactivationPeriodDefaultValue = (
  currentFacilityDateTime: Date,
  facilityOffset: number,
  deactivateTable?: IDeactivateTable,
) => {
  const currentDateTime = currentFacilityDateTime || new Date();

  if (deactivateTable) {
    const startDate = addMinutes(new Date(deactivateTable?.start_date), facilityOffset * 60);
    const endDate = deactivateTable.end_date
      ? addMinutes(new Date(deactivateTable.end_date), facilityOffset * 60)
      : addDays(currentDateTime, 1);
    const remindDate = deactivateTable.remind_date
      ? addMinutes(new Date(deactivateTable.remind_date), facilityOffset * 60)
      : null;

    return {
      [EDIT_DEACTIVATION_PERIOD_FIELDS.IS_INDEFINITELY]: deactivateTable.end_date ? 0 : 1,
      [EDIT_DEACTIVATION_PERIOD_FIELDS.DEACTIVATE_DATE]: startDate,
      [EDIT_DEACTIVATION_PERIOD_FIELDS.DEACTIVATE_RANGE_START]: startDate,
      [EDIT_DEACTIVATION_PERIOD_FIELDS.DEACTIVATE_RANGE_END]: endDate,
      [EDIT_DEACTIVATION_PERIOD_FIELDS.REMIND_DATE]: remindDate,
    };
  }

  return {
    [EDIT_DEACTIVATION_PERIOD_FIELDS.IS_INDEFINITELY]: 0,
    [EDIT_DEACTIVATION_PERIOD_FIELDS.DEACTIVATE_DATE]: currentDateTime,
    [EDIT_DEACTIVATION_PERIOD_FIELDS.DEACTIVATE_RANGE_START]: currentDateTime,
    [EDIT_DEACTIVATION_PERIOD_FIELDS.DEACTIVATE_RANGE_END]: addDays(currentDateTime, 1),
  };
};
